<p-dialog
    [(visible)]="displayDialog"
    [style]="{ width: '50vw' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    (onHide)="onDialogClosed()"
    header="Renumerar Pregunta"
>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" appPermissionControl="P279F0001">
        <div class="form-row">
            <div class="form-field">
                <input pInputText type="text" formControlName="origen" class="form-control" readonly appPermissionControl="P279K0001">
                <label>N° Pregunta Origen</label>
            </div>
            <div class="form-field">
                <input pInputText type="number" formControlName="destino" class="form-control" min="1" appPermissionControl="P279K0002">
                <label>N° Pregunta Destino</label>
            </div>
        </div>

        <div class="button-section mt-3">
            <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading" appPermissionControl="P279B0001">
                <mat-icon *ngIf="!loading">save</mat-icon>
                <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8"
                    fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                Guardar
            </button>
        </div>
    </form>
</p-dialog>

<p-toast position="bottom-right"></p-toast> 